import React, { useState } from "react";
// @ts-ignore
const EditorOneStringContent = ({ content, handleContentChange, index }) => {
    const [isVisible, setIsVisible] = useState(content.content.length === 0);

    return (
        <>
            <label>
                H2:
                <button onClick={() => setIsVisible(!isVisible)}>
                    {isVisible ? "👁" : "👁"}
                </button>
            </label>
            {isVisible && (
                <input
                    value={content.content}
                    className="text-content"
                    onChange={(e) => handleContentChange(index, { ...content, content: e.target.value })}
                />
            )}
        </>
    );
};

export default EditorOneStringContent;